__turbopack_context__.v({
  "className": "raleway_333ab3f2-module__VzvEcG__className",
});
